





































import { Currency } from "@/shared/models/currency";
import { FinancialSettingsType } from "@/store/modules/financial";
import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { FinDocViewModel, FinDocRelatedAdvanceViewModel } from "./models";

@Component
export default class AdvancePicker extends Vue {
  @Prop() open?: boolean;
  @PropSync("finDocModel") finDocModelInternal!: FinDocViewModel;

  get allAdvances() {
    return this.finDocModelInternal.relatedAdvanceInvoices
      .concat(this.finDocModelInternal.unassignedAdvanceInvoices)
      .sort((a, b) => a.id - b.id);
  }

  @Getter("codebooks/currencies") currencies?: Currency[];

  @Getter("appParams/cashRegisterFeatureFlag")
  cashRegisterFeature?: boolean;

  formatDocName(doc: FinDocRelatedAdvanceViewModel) {
    const currency =
      (this.currencies ?? []).find((x) => x.id === doc.workingCurrencyId)
        ?.isoCode ?? "";

    const amount =
      doc.totalDueAmount || doc.totalDueAmount === 0
        ? `(${doc.totalDueAmount.toFixed(2)} ${currency})`
        : "";

    const name =
      (this.storedSettings?.setFiscalNumberAsMain
        ? doc.documentIdentifier
        : doc.documentInternalIdentifier) ?? `id:${doc.id}`;

    const typeName = this.$t(
      "t.FinancialDocumentTypes.AdvanceInvoice"
    ).toString();

    return [typeName, name, amount].filter((x) => x).join(" ");
  }

  isSelected(doc: FinDocRelatedAdvanceViewModel) {
    return !!this.finDocModelInternal?.relatedAdvanceInvoices.find(
      (x) => doc.id === x.id
    );
  }

  toggle(evt: any, doc: FinDocRelatedAdvanceViewModel) {
    if (!this.finDocModelInternal.relatedAdvanceInvoices) {
      this.finDocModelInternal.relatedAdvanceInvoices = [];
    }

    if (evt) {
      this.finDocModelInternal.relatedAdvanceInvoices.push(doc);
      this.finDocModelInternal.unassignedAdvanceInvoices =
        this.finDocModelInternal.unassignedAdvanceInvoices.filter(
          (e) => e.id !== doc.id
        );
    } else {
      this.finDocModelInternal.unassignedAdvanceInvoices.push(doc);
      this.finDocModelInternal.relatedAdvanceInvoices =
        this.finDocModelInternal.relatedAdvanceInvoices.filter(
          (e) => e.id !== doc.id
        );
    }
  }

  @Getter("financial/settings") storedSettings?: FinancialSettingsType;
}
